export const floors = [
  { id: '1º Andar', label: '1º Andar' },
  { id: '2º Andar', label: '2º Andar' },
  { id: '3º Andar', label: '3º Andar' },
  { id: 'Área Externa', label: 'Área Externa' },
  { id: 'Área Técnica', label: 'Área Técnica' }
];
